import React,{useState} from 'react'
import { useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";

const INASpage = () => {
    const [searchCanId, setSearchCanId] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [flag,setFlag]=useState(false);


    const handleSearchCanID = async () => {
        try {
          setLoading(true);
          const apiUrl = process.env.REACT_APP_API_URL;
          const requestData = {
            "Action": "getPowerByONT",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "CanId": searchCanId,
            "ONTSerialNo": searchCanId
        }
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          });
          const result = await response.json();
          // console.log("getPowerByONT", result);
          // console.log("getPowerByONT Status", result.Status);
          if (result.Status==="Success") {
            // console.log("getPowerByONT Response", result.Response);
            setSearchData(result.Response); 
            setFlag(true);
          } else {
            toast.warning(result.Message , {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      };

    const navigate=useNavigate()
    const redirectDashboardPage=()=>{
        navigate('/dashboard');
        //console.log('click');
    }
  return (
    <>
        {/* ******************header********************** */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectDashboardPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">INAS</span>
        </div>
      </div>
    {/* *********************Header end *************************** */}
      <div
        className="container-fluid mb-1  p-2 Searchbar-bg"
        style={{ marginTop: "63px" }}
      >
        <div className=" d-flex  justify-content-center align-items-center">
          <span>
            <input
              type="text"
              className="search-box p-1 border-0 inas-ctm"
              placeholder="CAN ID/ONT Serial No."
              value={searchCanId}
              onChange={(e) => setSearchCanId(e.target.value)}
            />
            <i
              className="fas fa-search text-secondary"
              style={{ marginLeft: "-25px" }}
            ></i>
          </span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button
            className="btn-s border-0 text-light"
            style={{backgroundColor:"rgb(148,101,170)" , padding:"4px"}}
            onClick={handleSearchCanID}
          >
            GET INAS INFO
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : (
        flag && (
        <div className="container-fluid mt-2">
          <div className="row justify-content-center">
          { searchData && (
              <div className=" col-12 col-md-6">
                <div className="card mb-3 mt-2  mx-auto shadow">
                  <div className="p-2 m-2 srDetails-card">
                      <div className="row">
                          <div className="col-5 text-weight-color">Active Status</div>
                          <div className="col-1 ">:</div>
                          <div className="col-6 text-success">{searchData.ActiveStatus}</div>
                      </div>
                      <div className="row">
                          <div className="col-5 text-weight-color" >Power Level</div>
                          <div className="col-1">:</div>
                          <div className="col-6 text-success">{searchData.PowerLevel}</div>
                      </div>
                      <div className="row">
                          <div className="col-5 text-weight-color">Alarm Details</div>
                          <div className="col-1">:</div>
                          <div className="col-6">{searchData.AlarmsInfo}</div>
                      </div>
                      <div className="row">
                          <div className="col-5 text-weight-color">Fibre Distance</div>
                          <div className="col-1">:</div>
                          <div className="col-6">{searchData.FiberDistance}</div>
                      </div>
                      <div className="row">
                          <div className="col-5 text-weight-color">IP Address</div>
                          <div className="col-1">:</div>
                          <div className="col-6">{searchData.IPAddress}</div>
                      </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>)
      )}
    </>
  )
}

export default INASpage
